.shell {
  min-height: 100vh;
  min-height: 100dvh;
  color: var(--color-foreground);
  background: var(--color-background);
}

.sidebarPanel {
  position: sticky;
  top: 0;
  width: 17rem;
  min-width: 17rem;
  max-width: min(32rem, 50vw);
  flex-shrink: 0;
  height: 100dvh !important;
  background: var(--color-background);
  box-shadow: inset -1px 0 var(--color-border);
}

.contentPanel {
  --portal-topbar-height: calc(4rem + env(safe-area-inset-top));
  min-width: 0;
  max-width: 100%;
  flex: 1;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--color-background-2);
  // The page fills the column, so a footer after it sits at the bottom of short pages.
  display: flex;
  flex-direction: column;
}

.main {
  flex: 1 0 auto;

  // A page that ends in a bar along the bottom (the portal's next-step bar, `mt-auto`) lays out as
  // a column, so on a short page the bar sits at the bottom of the window, not under the content.
  // Only then: a column would shrink centred children without a width, such as the docs shell.
  &:has(> [data-page-end-bar]) {
    display: flex;
    flex-direction: column;
  }
}

.embeddedContentPanel {
  --portal-topbar-height: 0px;
  max-width: 100%;
}

.topbar {
  position: sticky;
  z-index: 30;
  top: 0;
  padding-top: env(safe-area-inset-top);
  border-bottom: 1px solid var(--color-border);
  background: color-mix(in srgb, var(--color-background) 86%, transparent);
  backdrop-filter: blur(1rem);
}

.navigation {
  position: fixed;
  z-index: 60;
  inset: 0;
  pointer-events: none;
}

.navigationBackdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: color-mix(in srgb, var(--color-foreground) 22%, transparent);
  pointer-events: auto;
}

.navigationPanel {
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  width: min(19rem, 88vw);
  overflow: hidden;
  border-inline-end: 1px solid var(--color-border);
  background: var(--color-background);
  box-shadow: calc(1rem * var(--inline-sign)) 0 2.5rem color-mix(in srgb, var(--color-foreground) 14%, transparent);
  pointer-events: auto;
  animation: navigationShow 160ms ease-out;
  padding-top: env(safe-area-inset-top);

  &:focus {
    outline: none;
  }
}

// The panel carries the sidebar's theme, so the button takes its colours from there.
.navigationCloseButton {
  position: absolute;
  z-index: 10;
  top: calc(0.75rem + env(safe-area-inset-top));
  inset-inline-end: 0.75rem;
}

@keyframes navigationShow {
  from {
    transform: translateX(calc(-100% * var(--inline-sign)));
  }

  to {
    transform: translateX(0);
  }
}

@media (min-width: 768px) {
  .mobileNavigation {
    display: none;
  }
}

@media (max-width: 767px) {
  .splitPane {
    display: block !important;

    :global(.w-split-bar) {
      display: none !important;
    }
  }

  .sidebarPanel {
    display: none;
  }

  .contentPanel {
    width: 100% !important;
    max-width: 100% !important;
  }

  .topbar {
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }

  .navigationPanel {
    padding-left: env(safe-area-inset-left);

    // Safe-area insets are physical: pad the screen edge the panel sits against.
    &:dir(rtl) {
      padding-left: 0;
      padding-right: env(safe-area-inset-right);
    }

    padding-bottom: env(safe-area-inset-bottom);
  }
}

@media (prefers-reduced-motion: reduce) {
  .navigationPanel {
    animation: none;
  }
}

// The split library makes panes relative while dragging; keep the navigation pinned.
.shell .splitPane:global(.dragging) > .sidebarPanel {
  position: sticky;
}
